import { useEffect } from "react";

type HotkeyOpts = {
  isTyping: () => boolean;
  showSettings: boolean;
  closeSettings: () => void;
  setSelectedNodeIds: (ids: string[]) => void;
  setSelectedEdgeIds: (ids: string[]) => void;
  showHotkeys: boolean;
  setShowHotkeys: (v: boolean) => void;
  overviewNode: any;
  setOverviewNode: (node: any) => void;
  handleUndo: () => void;
  handleRedo: () => void;
  deleteSelection: () => void;
  focusSearch: () => void;
  focusOrFit: (fitAll?: boolean) => void;
  persist: () => void;
  duplicateSelection: () => void;
  addNode: () => void;
  selectedEdgeIds: string[];
  updateSelectedEdgeStyle: (patch: any) => void;
};

export function useEditorHotkeys(opts: HotkeyOpts) {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (!event.key) return;
      const key = event.key.toLowerCase();
      const mod = event.metaKey || event.ctrlKey;
      const typing = opts.isTyping();

      if (key === "escape") {
        if (opts.showSettings) {
          opts.closeSettings();
        } else {
          opts.setSelectedNodeIds([]);
          opts.setSelectedEdgeIds([]);
        }
        if (opts.showHotkeys) opts.setShowHotkeys(false);
        if (opts.overviewNode) opts.setOverviewNode(null);
        return;
      }

      if (typing) return;

      if (mod && key === "z") {
        event.preventDefault();
        if (event.shiftKey) opts.handleRedo();
        else opts.handleUndo();
        return;
      }
      if (mod && key === "y") {
        event.preventDefault();
        opts.handleRedo();
        return;
      }

      if (key === "delete" || key === "backspace") {
        event.preventDefault();
        opts.deleteSelection();
        return;
      }

      if (mod && key === "f") {
        event.preventDefault();
        opts.focusSearch();
        return;
      }

      if (key === "f" && !mod) {
        event.preventDefault();
        opts.focusOrFit(event.shiftKey ? true : false);
        return;
      }

      if (mod && key === "s") {
        event.preventDefault();
        opts.persist();
        return;
      }

      if (mod && key === "d") {
        event.preventDefault();
        opts.duplicateSelection();
        return;
      }

      if (key === "n" && !mod) {
        event.preventDefault();
        opts.addNode();
        return;
      }

      if (key === "?" && !mod) {
        event.preventDefault();
        opts.setShowHotkeys(!opts.showHotkeys);
        return;
      }

      if (opts.selectedEdgeIds.length > 0) {
        if (key === "1") {
          event.preventDefault();
          opts.updateSelectedEdgeStyle({ line_style: "straight" });
          return;
        }
        if (key === "2") {
          event.preventDefault();
          opts.updateSelectedEdgeStyle({ line_style: "step" });
          return;
        }
        if (key === "3") {
          event.preventDefault();
          opts.updateSelectedEdgeStyle({ line_style: "bezier" });
          return;
        }
        if (key === "r") {
          event.preventDefault();
          opts.updateSelectedEdgeStyle({ arrow_style: "reverse" });
          return;
        }
        if (key === "b") {
          event.preventDefault();
          opts.updateSelectedEdgeStyle({ arrow_style: "both" });
          return;
        }
        if (key === "n") {
          event.preventDefault();
          opts.updateSelectedEdgeStyle({ arrow_style: "none" });
          return;
        }
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [opts]);
}
